import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { LegalSection, PLATFORM_URL } from '../components/LegalPage';
import { BRAND } from '../config/brand';

const cellClass = 'border px-3 py-2 align-top text-sm';

const CookiePolicyPage = () => {
  return (
    <LegalPage title="Cookie Policy">
      <LegalSection title="1. Premesse">
        <p>
          La presente Cookie Policy &egrave; resa da {BRAND.legalName} (di seguito anche
          &ldquo;{BRAND.companyName}&rdquo; o &ldquo;Titolare&rdquo;) in relazione all&apos;utilizzo di
          cookie e tecnologie similari da parte di {BRAND.productName}, la piattaforma disponibile
          all&apos;indirizzo {PLATFORM_URL} (la &ldquo;Piattaforma&rdquo;).
        </p>
        <p>
          I cookie sono piccoli file di testo che i siti visitati salvano sul dispositivo
          dell&apos;utente per poi rileggerli alle visite successive. Tecnologie similari sono, ad
          esempio, l&apos;archiviazione locale del browser (local storage).
        </p>
      </LegalSection>

      <LegalSection title="2. In sintesi">
        <p>
          La Piattaforma utilizza <strong>esclusivamente strumenti tecnici</strong> necessari al suo
          funzionamento. Non utilizza cookie di profilazione o di marketing, strumenti di analisi
          statistica del traffico (come Google Analytics) o pixel pubblicitari. Per questo non &egrave;
          richiesto il consenso dell&apos;utente: il banner mostrato al primo accesso ha finalit&agrave;
          informativa.
        </p>
      </LegalSection>

      <LegalSection title="3. Strumenti tecnici utilizzati">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse" style={{ borderColor: '#E4DFD2' }}>
            <thead>
              <tr className="text-left" style={{ backgroundColor: '#F1F4F5' }}>
                <th className={cellClass}>Nome</th>
                <th className={cellClass}>Tipo</th>
                <th className={cellClass}>Finalit&agrave;</th>
                <th className={cellClass}>Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={cellClass}><code>cookie_notice</code></td>
                <td className={cellClass}>Cookie tecnico di prima parte</td>
                <td className={cellClass}>Ricorda che l&apos;utente ha preso visione dell&apos;avviso sui cookie, per non mostrarlo a ogni visita</td>
                <td className={cellClass}>12 mesi</td>
              </tr>
              <tr>
                <td className={cellClass}><code>access_token</code></td>
                <td className={cellClass}>Local storage tecnico di prima parte</td>
                <td className={cellClass}>Mantiene l&apos;utente autenticato durante l&apos;uso dell&apos;area riservata</td>
                <td className={cellClass}>Validit&agrave; di 15 minuti; eliminato al logout</td>
              </tr>
              <tr>
                <td className={cellClass}><code>refresh_token</code></td>
                <td className={cellClass}>Local storage tecnico di prima parte</td>
                <td className={cellClass}>Rinnova l&apos;autenticazione senza richiedere nuovamente le credenziali</td>
                <td className={cellClass}>Validit&agrave; di 7 giorni; eliminato al logout</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Base giuridica: esecuzione del servizio richiesto dall&apos;utente e legittimo interesse alla
          sicurezza (art. 6, par. 1, lett. b e f GDPR; art. 122 D.lgs. 196/2003). Il consenso non
          &egrave; richiesto.
        </p>
      </LegalSection>

      <LegalSection title="4. Risorse di terze parti">
        <p>
          I caratteri tipografici della Piattaforma sono caricati tramite il servizio Google Fonts
          (Google Ireland Ltd. / Google LLC). Per fornire i caratteri, il browser dell&apos;utente si
          collega ai server di Google trasmettendo i dati tecnici necessari alla connessione, tra cui
          l&apos;indirizzo IP. Il servizio non installa cookie sulla Piattaforma. Maggiori informazioni
          sono disponibili nell&apos;informativa privacy di Google (policies.google.com/privacy).
        </p>
        <p>
          I collegamenti a siti esterni (ad esempio le pagine delle stazioni appaltanti, LinkedIn o
          WhatsApp) portano a servizi gestiti da altri titolari, che trattano i dati secondo le proprie
          informative.
        </p>
      </LegalSection>

      <LegalSection title="5. Come gestire i cookie">
        <p>
          L&apos;utente pu&ograve; cancellare in qualsiasi momento i cookie e i dati salvati dal browser
          tramite le impostazioni del browser stesso. La cancellazione dei dati tecnici comporta il
          logout dalla Piattaforma e la nuova visualizzazione dell&apos;avviso sui cookie; il blocco dei
          cookie e dell&apos;archiviazione locale pu&ograve; impedire l&apos;accesso all&apos;area riservata.
        </p>
        <p>
          Qualora in futuro vengano introdotti strumenti non tecnici, saranno attivati solo previo
          consenso e previo aggiornamento della presente Cookie Policy.
        </p>
      </LegalSection>

      <LegalSection title="6. Rapporto con la Privacy Policy e diritti dell'interessato">
        <p>
          Per le informazioni complete sul trattamento dei dati personali, inclusi finalit&agrave;,
          basi giuridiche, destinatari e diritti dell&apos;interessato (artt. 15&ndash;22 GDPR), si rinvia
          alla <Link to="/privacy" className="underline">Privacy Policy</Link>. Le richieste possono essere
          inviate a {BRAND.privacyEmail}.
        </p>
      </LegalSection>

      <LegalSection title="7. Aggiornamenti della Cookie Policy">
        <p>
          La presente Cookie Policy pu&ograve; essere modificata o aggiornata, anche in conseguenza di
          evoluzioni normative o tecniche. La data dell&apos;ultima revisione &egrave; indicata in alto.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default CookiePolicyPage;
